import type Result from 'true-myth/result';

import type { JobArchitecture } from '~/shared/data-contract/job-architecture';
import type { HttpFetcherWithBaseUrl } from '~/shared/http-fetcher';

export type GenerateJobFamiliesWithAi = (jobArchitecture: JobArchitecture) => Promise<Result<unknown, Error>>;

const generateWithAiRequestTimeout = 60_000;

export const createGenerateJobFamiliesWithAi = (dependencies: {
    readonly cobrainerApiFetcher: HttpFetcherWithBaseUrl;
}): GenerateJobFamiliesWithAi => {
    const { cobrainerApiFetcher } = dependencies;

    return (jobArchitecture) => {
        return cobrainerApiFetcher.post({
            pathname: `/job-architectures/${jobArchitecture.id}/families/generate?async=true`,
            requestOptions: {
                timeout: generateWithAiRequestTimeout,
            },
        });
    };
};
